import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

// isAuthCheckSkipped нужен, чтобы клиент API не проверял свежесть токенов для этого действия
async function login({ email, password }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/Login',
    data: sanitizePostData({ email, password }),
    isAuthCheckSkipped: true,
    generalErrorsOnly: true,
  });
  return data;
}

async function externalLogin({ authResponse, providerType }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/ExternalLogin',
    data: sanitizePostData({ authResponse, providerType }),
    isAuthCheckSkipped: true,
  });
  return data;
}

async function googleLogin({ code}) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/GoogleLogin',
    data: sanitizePostData({ code }),
    isAuthCheckSkipped: true,
  });
  return data;
}

async function wantToRegisterInTavern({ emailAddress, message }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/WantToRegisterInTavern',
    data: sanitizePostData({ emailAddress, message }),
    isAuthCheckSkipped: true,
  });
  return data;
}

async function refreshToken({ token }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/RefreshToken',
    data: { token },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function register({ email, password, confirmPassword }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/Register',
    data: sanitizePostData({ email, password, confirmPassword }),
    isAuthCheckSkipped: true,
    generalErrorsOnly: true,
  });
  return data;
}

async function resetPassword({ email, password, confirmPassword, code }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/ResetPassword',
    data: sanitizePostData({ email, password, confirmPassword, code }),
    isAuthCheckSkipped: true,
    generalErrorsOnly: true,
  });
  return data;
}

async function sendResetPasswordCode({ email }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/SendResetPasswordCode',
    data: sanitizePostData({ email }),
    isAuthCheckSkipped: true,
  });
  return data;
}

async function changePassword({ password, confirmPassword, currentPassword }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/ChangePassword',
    data: sanitizePostData({ password, confirmPassword, currentPassword }),
    isAuthCheckSkipped: true,
  });
  return data;
}

async function deleteAccount() {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/DeleteAccount',
    isAuthCheckSkipped: true,
  });
  return data;
}

async function sendInviteToTavern({ email }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/SendInviteToTavern',
    data: sanitizePostData({ email }),
    generalErrorsOnly: true,
  });
  return data;
}

async function acceptInvitation({ password, email, confirmPassword, code }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/AcceptInvitation',
    data: sanitizePostData({ password, email, confirmPassword, code }),
    generalErrorsOnly: true,
    isAuthCheckSkipped: true,
  });
  return data;
}

async function confirmEmail({ email, code }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Account/ConfirmEmail',
    data: sanitizePostData({ email, code }),
    generalErrorsOnly: true,
    isAuthCheckSkipped: true,
  });
  return data;
}

export {
  login,
  externalLogin,
  googleLogin,
  refreshToken,
  register,
  resetPassword,
  sendResetPasswordCode,
  changePassword,
  deleteAccount,
  sendInviteToTavern,
  acceptInvitation,
  confirmEmail,
  wantToRegisterInTavern
};
